import styled from 'styled-components';
import { COLORS } from '@app/src/ui';

interface Props {
  borderRadius: string;
}

export const WrapperModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.4);
  z-index: 2100;
  display: flex;
  right: 0;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  outline: 0!important;
  font-family: sans-serif;
`;

export const WrapperModalBody = styled.div`
  position: relative;
  word-wrap: break-word;
  overflow-x: hidden;
  max-height: 90%;
  min-width: 80px;
  min-height: 60px;
  background-color: #fff;
  border-radius: ${(props: Props) => props.borderRadius ? props.borderRadius : '5px'}
`;

export const WrapperHeaderSection = styled.section`
  display: flex;
  justify-content: flex-end;
`;

export const WrapperCloseIcon = styled.button`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 8px;
  padding-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;
  background-color: transparent;
  border: none;
  z-index: 1;
  &:hover {
    background-color: ${COLORS.GRAY_LIGHT};
  }
`;

export const WrapperAlert = styled.div`
  max-width: 300px;
  width: 250px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -15px;
  font-size:25px;
  font-family: gotham-book;
`;

export const AlertMessage = styled.p`
  text-align: center;
`;
